import {
  ADD_LOAN,
  ADD_LOAN_FAILURE,
  ADD_LOAN_SUCCESS,
  CANCEL_CHANGE_MAILING_ADDRESS,
  CANCEL_CHANGE_MAILING_ADDRESS_FAILURE,
  CANCEL_CHANGE_MAILING_ADDRESS_SUCCESS,
  CHANGE_INPUT,
  CHANGE_MAILING_ADDRESS,
  CHANGE_MAILING_ADDRESS_FAILURE,
  CHANGE_MAILING_ADDRESS_FORM_TYPE,
  CHANGE_MAILING_ADDRESS_SUCCESS,
  CHANGE_MAILING_ADDRESS_VALIDATION_FAILURE,
  CHANGE_PRIMARY_LOAN,
  CHANGE_PRIMARY_LOAN_FAILURE,
  CHANGE_PRIMARY_LOAN_SUCCESS,
  CHANGE_STEP,
  CHOOSE_DOCUMENT,
  CHOOSE_DOCUMENT_CANCELLATION,
  CHOOSE_DOCUMENT_FAILURE,
  CHOOSE_DOCUMENT_SUCCESS,
  CLOSE_MODAL_STATE,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_DOCUMENT_FAILURE,
  FETCH_MAILING_ADDRESS,
  FETCH_MAILING_ADDRESS_ALL,
  FETCH_MAILING_ADDRESS_ALL_FAILURE,
  FETCH_MAILING_ADDRESS_ALL_SUCCESS,
  FETCH_MAILING_ADDRESS_FAILURE,
  FETCH_MAILING_ADDRESS_SUCCESS,
  FETCH_MAILING_ADDRESS_VALIDATION_FAILURE,
  INPUT_ERRORS,
  OPEN_MODAL_STATE,
  PROCESS_DOCUMENT,
  PROCESS_DOCUMENT_FAILURE,
  PROCESS_DOCUMENT_SUCCESS,
  RESET_BANNER_ERROR,
  RESET_ERROR_STATE,
  RESET_FORM_STATE,
  RESET_FORM_TYPE,
  RESET_SELECTED_LOAN,
  RESET_STATE,
  RESET_STATUS_STATE,
  RESET_STEP_STATE,
  RESET_UPDATED_PRIMARY_LOAN,
  SET_SELECTED_LOAN,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_DOCUMENT_SUCCESS,
} from './constants';

export function addLoan({
  isPrimaryLoan,
  lastFourSsn,
  loanNumber,
  propertyZip,
}) {
  return {
    payload: {
      isPrimaryLoan,
      lastFourSsn,
      loanNumber,
      propertyZip,
    },
    type: ADD_LOAN,
  };
}

export function addLoanFailure(error) {
  return {
    payload: { error },
    type: ADD_LOAN_FAILURE,
  };
}

export function addLoanSuccess() {
  return { type: ADD_LOAN_SUCCESS };
}

export function cancelChangeMailingAddress() {
  return { type: CANCEL_CHANGE_MAILING_ADDRESS };
}

export function cancelChangeMailingAddressFailure() {
  return { type: CANCEL_CHANGE_MAILING_ADDRESS_FAILURE };
}

export function cancelChangeMailingAddressSuccess() {
  return { type: CANCEL_CHANGE_MAILING_ADDRESS_SUCCESS };
}

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeMailingAddress(requestBody) {
  return {
    payload: { requestBody },
    type: CHANGE_MAILING_ADDRESS,
  };
}

export function changeMailingAddressFailure(error) {
  return {
    payload: { error },
    type: CHANGE_MAILING_ADDRESS_FAILURE,
  };
}

export function changeMailingAddressSuccess() {
  return { type: CHANGE_MAILING_ADDRESS_SUCCESS };
}

export function changeMailingAddressType(mailingAddressType) {
  return {
    payload: { mailingAddressType },
    type: CHANGE_MAILING_ADDRESS_FORM_TYPE,
  };
}

export function changeMailingAddressValidationFailure(formToUse, updatedState) {
  return {
    payload: { formToUse, updatedState },
    type: CHANGE_MAILING_ADDRESS_VALIDATION_FAILURE,
  };
}

export function changePrimaryLoan(loanNumber) {
  return {
    payload: { loanNumber },
    type: CHANGE_PRIMARY_LOAN,
  };
}

export function changePrimaryLoanFailure(error) {
  return {
    payload: { error },
    type: CHANGE_PRIMARY_LOAN_FAILURE,
  };
}

export function changePrimaryLoanSuccess({ loan, message }) {
  return {
    payload: { loan, message },
    type: CHANGE_PRIMARY_LOAN_SUCCESS,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function chooseDocument({ reviewScreenName, type }) {
  return {
    payload: { reviewScreenName, type },
    type: CHOOSE_DOCUMENT,
  };
}

export function chooseDocumentCancellation() {
  return { type: CHOOSE_DOCUMENT_CANCELLATION };
}

export function chooseDocumentFailure({ bannerError }) {
  return {
    payload: { bannerError },
    type: CHOOSE_DOCUMENT_FAILURE,
  };
}

export function chooseDocumentSuccess() {
  return { type: CHOOSE_DOCUMENT_SUCCESS };
}

export function closeModalState() {
  return { type: CLOSE_MODAL_STATE };
}

export function downloadDocument(fileUrl) {
  return {
    payload: { fileUrl },
    type: DOWNLOAD_DOCUMENT,
  };
}

export function downloadDocumentFailure(error) {
  return {
    payload: { error },
    type: DOWNLOAD_DOCUMENT_FAILURE,
  };
}

export function fetchMailingAddress(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_MAILING_ADDRESS,
  };
}

export function fetchMailingAddressFailure(error) {
  return {
    payload: { error },
    type: FETCH_MAILING_ADDRESS_FAILURE,
  };
}

export function fetchMailingAddressSuccess(addressStatus, loanNumber) {
  return {
    payload: { addressStatus, loanNumber },
    type: FETCH_MAILING_ADDRESS_SUCCESS,
  };
}

export function fetchMailingAddressValidationFailure(error) {
  return {
    payload: { error },
    type: FETCH_MAILING_ADDRESS_VALIDATION_FAILURE,
  };
}

export function fetchMailingAddressAll() {
  return { type: FETCH_MAILING_ADDRESS_ALL };
}

export function fetchMailingAddressAllFailure(error) {
  return {
    payload: { error },
    type: FETCH_MAILING_ADDRESS_ALL_FAILURE,
  };
}

export function fetchMailingAddressAllSuccess(allAddressData, countryProvinceStateData) {
  return {
    payload: { allAddressData, countryProvinceStateData },
    type: FETCH_MAILING_ADDRESS_ALL_SUCCESS,
  };
}

export function inputErrors({ form, formErrors }) {
  return {
    payload: { form, formErrors },
    type: INPUT_ERRORS,
  };
}

export function openModalState({ modalState }) {
  return {
    payload: { modalState },
    type: OPEN_MODAL_STATE,
  };
}

export function processDocument({ file, mobile }) {
  return {
    payload: { file, mobile },
    type: PROCESS_DOCUMENT,
  };
}

export function processDocumentFailure({ bannerError, file, validationError } = {}) {
  return {
    payload: { bannerError, file, validationError },
    type: PROCESS_DOCUMENT_FAILURE,
  };
}

export function processDocumentSuccess({ file }) {
  return {
    payload: { file },
    type: PROCESS_DOCUMENT_SUCCESS,
  };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetErrorState() {
  return { type: RESET_ERROR_STATE };
}

export function resetFormState(formKeys) {
  return {
    payload: { formKeys },
    type: RESET_FORM_STATE,
  };
}

export function resetFormType() {
  return { type: RESET_FORM_TYPE };
}

export function resetSelectedLoan() {
  return { type: RESET_SELECTED_LOAN };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function resetStatusState(statusKeys) {
  return {
    payload: { statusKeys },
    type: RESET_STATUS_STATE,
  };
}

export function resetStepState() {
  return { type: RESET_STEP_STATE };
}

export function setSelectedLoan({ loanNumber }) {
  return {
    payload: { loanNumber },
    type: SET_SELECTED_LOAN,
  };
}

export function resetUpdatedPrimaryLoan() {
  return { type: RESET_UPDATED_PRIMARY_LOAN };
}

export function uploadDocument({
  document,
  documentCategory,
  documentSize,
  formValues,
  loanNumber,
}) {
  return {
    payload: {
      document,
      documentCategory,
      documentSize,
      formValues,
      loanNumber,
    },
    type: UPLOAD_DOCUMENT,
  };
}

export function uploadDocumentFailure({ bannerError, validationError } = {}) {
  return {
    payload: { bannerError, validationError },
    type: UPLOAD_DOCUMENT_FAILURE,
  };
}

export function uploadDocumentSuccess() {
  return { type: UPLOAD_DOCUMENT_SUCCESS };
}
